import React, { FC } from 'react';
import { useDate, useName } from '~/hooks';
import { BlockComment } from '@bechtel/types';
import { Box, Avatar, Text, AvatarSize } from '@bechtel/gds';
import { BlockCommentContainerStyled, BlockCommentStyled } from './styled';
import { CommentHistoryProps } from './types';
import { map } from 'lodash';

export const CommentHistory: FC<CommentHistoryProps> = ({ blockStatus, blockComments, canEditBlock }) => {
  const { formatISODate, formatTime } = useDate();
  const { getFullName } = useName();

  return (
    <BlockCommentContainerStyled blockStatus={blockStatus} canEditBlock={canEditBlock} data-testid="comments">
      {map(blockComments, (blockComment: BlockComment) => {
        const time = formatTime(blockComment.createdAt);
        const day = formatISODate(blockComment.createdAt);
        return (
          <Box px={{ sm: '500' }} pt={{ sm: '500' }} flexDirection={{ sm: 'column' }} key={blockComment.id}>
            <Box alignItems={{ sm: 'center' }}>
              <Avatar
                size={AvatarSize.MEDIUM}
                src={blockComment.createdBy.imageUrl ? blockComment.createdBy.imageUrl : undefined}
              />
              <Box flexDirection={{ sm: 'column' }} ml={{ sm: '200' }}>
                <Text size={400} weight={600} color="grey.1000">
                  {getFullName(blockComment.createdBy.firstName, blockComment.createdBy.lastName)}
                </Text>
                <Box mt={{ sm: '200' }}>
                  <Text size={300} color="grey.600">
                    {day}-{time}
                  </Text>
                </Box>
              </Box>
            </Box>
            <BlockCommentStyled>
              <Text size={400} color="grey.1000">
                {blockComment.comment}
              </Text>
            </BlockCommentStyled>
          </Box>
        );
      })}
    </BlockCommentContainerStyled>
  );
};
